import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { NavLink } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { keyEmptyCheck } from 'aurora-utils/utils';
import styles from './sidebar-jss';

const LinkBtn = React.forwardRef(function LinkBtn(props, ref) { // eslint-disable-line
  return <NavLink to={props.to} {...props} innerRef={ref} />; // eslint-disable-line
});

// eslint-disable-next-line
function MainMenu(props) {
  const { classes, dataMenu, toggleDrawerOpen, loadTransition } = props;

  const handleClick = () => {
    toggleDrawerOpen();
    loadTransition(false);
  };

  const getMenus = menuArray =>
    menuArray.map(item => (
      <ListItem
        key={item.key}
        button
        exact
        activeClassName={classes.active}
        component={LinkBtn}
        to={item.linkParent}
        onClick={handleClick}
      >
        <ListItemText classes={{ primary: classes.primary }} primary={keyEmptyCheck(item.name)} />
      </ListItem>
    ));

  return <div>{getMenus(dataMenu)}</div>;
}

MainMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleDrawerOpen: PropTypes.func.isRequired,
  loadTransition: PropTypes.func.isRequired,
  dataMenu: PropTypes.array.isRequired,
};

export default withStyles(styles)(MainMenu);
